export default function jumpBySeconds(seconds: number, playerInstance: jwInstance) {
  var time = playerInstance.getPosition() + seconds;
  if (time < 0) {
    time = 0;
  }
  playerInstance.seek(time);
}
